/*
  Tablya : scripts communs (chargé en defer depuis layout/theme.liquid).
  1. Apparition au défilement : ajoute « .vu » aux éléments « .tb-apparait » quand ils entrent à l'écran.
     L'état caché n'existe que si <html> porte « tb-js » (posée dans le <head>) : sans JS, tout reste visible.
  2. En-tête : ajoute « tb-defile » sur la section d'en-tête dès qu'on a défilé, pour l'ombre légère.

  API pour les autres scripts : window.Tablya.apparait(racine) observe les « .tb-apparait » ajoutés après coup.
  Un délai d'apparition se règle avec la variable CSS --tb-delai (ex. style="--tb-delai: .1s").
*/
(function () {
  'use strict';

  var racineDoc = document.documentElement;
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var observateur = null;

  function montrer(el) {
    el.classList.add('vu');
  }

  function elements(racine) {
    var liste = [];
    if (!racine || racine.nodeType !== 1) return liste;
    if (racine.classList.contains('tb-apparait')) liste.push(racine);
    var dedans = racine.querySelectorAll('.tb-apparait:not(.vu)');
    for (var i = 0; i < dedans.length; i++) liste.push(dedans[i]);
    return liste;
  }

  function apparait(racine) {
    var liste = elements(racine || document.body);
    if (!liste.length) return;

    // Pas d'IntersectionObserver, mouvement réduit ou éditeur de thème : on montre tout de suite
    if (!observateur || (reduit && reduit.matches) || window.Shopify && window.Shopify.designMode) {
      liste.forEach(montrer);
      return;
    }
    liste.forEach(function (el) {
      if (!el.classList.contains('vu')) observateur.observe(el);
    });
  }

  if ('IntersectionObserver' in window) {
    observateur = new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (entree) {
          if (entree.isIntersecting) {
            montrer(entree.target);
            observateur.unobserve(entree.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
  }

  // Contenu ajouté après le chargement (filtres de collection, « Voir plus », panier…)
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var ajoutes = mutations[i].addedNodes;
        for (var j = 0; j < ajoutes.length; j++) {
          if (ajoutes[j].nodeType === 1) apparait(ajoutes[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Éditeur de thème : une section rechargée repasse par l'observateur
  document.addEventListener('shopify:section:load', function (event) {
    apparait(event.target);
  });

  // Si l'utilisateur active « réduire les animations » en cours de route, on montre tout
  if (reduit && reduit.addEventListener) {
    reduit.addEventListener('change', function () {
      if (reduit.matches) elements(document.body).forEach(montrer);
    });
  }

  apparait(document.body);

  // ---------- En-tête : ombre légère au défilement ----------
  var enAttente = false;

  function majEntete() {
    enAttente = false;
    var entete = document.querySelector('.section-header');
    if (entete) entete.classList.toggle('tb-defile', window.scrollY > 10);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(majEntete);
    },
    { passive: true }
  );
  majEntete();

  window.Tablya = window.Tablya || {};
  window.Tablya.apparait = apparait;
  racineDoc.classList.add('tb-js');
})();
